import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import Paragraph from '../../Typography/Paragraph/Paragraph';
import styles from './LanguageBox.module.scss';
import { ReactComponent as LanguageIcon } from '../../../assets/icons/language.svg';
import { ReactComponent as ArrowDown } from '../../../assets/icons/arrow-down.svg';
import { useSelector } from 'react-redux';
const LanguageBox = ({ onClick, isComponentVisible, refTarget }) => {
    const { i18n } = useTranslation();
    const language = useSelector((state) => state.language.language);
    useEffect(() => {
        i18n.changeLanguage(language);
    }, [i18n, language]);
    return (_jsxs("div", Object.assign({ "data-testid": "languageBox", ref: refTarget, onClick: onClick, className: cn('d-flex align-items-center', styles.element, isComponentVisible && styles['isActive']) }, { children: [_jsx(LanguageIcon, {}), _jsxs("div", Object.assign({ className: cn(styles.language, 'd-flex align-items-center') }, { children: [_jsx(Paragraph, { fontFamily: 'marope', title: language }), isComponentVisible ? _jsx(ArrowDown, { className: styles.down }) : _jsx(ArrowDown, {})] }))] })));
};
export default LanguageBox;
